import React from 'react';

import { type HexAlpha } from '@nfctron/nexus-core';
import { type ExtendedComponent, useContextRequired } from '@nfctron/nexus-react';

import { Divider, useMantineTheme } from '@mantine/core';

import { EventCartPageContext } from '../CartContext';

/**
 * Event/Cart/TicketCardDivider component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const TicketCardDivider: React.FunctionComponent<TicketCardDividerProps> = ({ bgColor, children }) => {
	const { containerColors } = useContextRequired(EventCartPageContext);
	const theme = useMantineTheme();
	const backgroundColor = bgColor ?? theme.colors.gray[1] ?? containerColors.backgroundColor;

	return (
		<div className="relative flex items-center gap-3">
			{/* left cutout */}
			<div className="-ml-2 size-4 rounded-full border border-gray-200" style={{ backgroundColor }} />
			{/* cutout border overlay */}
			<div className="absolute top-0 bottom-0 -left-[9px] w-2 bg-white" style={{ backgroundColor }} />
			{/* divider */}
			<Divider variant="dashed" className="grow text-sm opacity-50" label={children} labelPosition="center" />
			{/* right cutout */}
			<div className="-mr-2 size-4 rounded-full border border-gray-200" style={{ backgroundColor }} />
			{/* cutout border overlay */}
			<div className="absolute top-0 -right-[9px] bottom-0 w-2 bg-white" style={{ backgroundColor }} />
		</div>
	);
};

/**
 * Event/Cart/TicketCardDivider component props type
 * @export
 */
export type TicketCardDividerProps = ExtendedComponent<{ bgColor?: HexAlpha }>;
